import React from 'react';
import { PharmacyInconsistencyHistory } from '../../../store/models/PharmacyInconsistencyHistory';
import { Instance } from 'mobx-state-tree';
import { DiscrepancyList } from './DiscrepancyList';
import { Translate } from '../../common/WithTranslate';
import { PharmacyStatus } from '../../../store/models';
import { ApplicationStore, PharmacyStore } from '../../../store';

export interface DiscrepancyPageProps {
  discrepancies: Array<Instance<typeof PharmacyInconsistencyHistory>>;
  pharmacyStatuses: Array<Instance<typeof PharmacyStatus>>;
  translate: Translate;
    PharmacyStore?: Instance<typeof PharmacyStore>;
    ApplicationStore?: Instance<typeof ApplicationStore>;
}

export const DiscrepancyPage = ({ discrepancies, pharmacyStatuses, translate, PharmacyStore, ApplicationStore }: DiscrepancyPageProps) => {
  return <DiscrepancyList discrepancies={discrepancies} translate={translate} pharmacyStatuses={pharmacyStatuses} ApplicationStore={ApplicationStore} PharmacyStore={PharmacyStore} />;
};
